<script lang="ts">
  import { navigate } from "../../app.logic";
  import CommentListEditor from "../../components/Business/CommentListEditor.svelte";
  import OwnershipListEditor from "../../components/Business/OwnershipListEditor.svelte";
  import PortalUserDropdown from "../../components/Business/PortalUserDropdown.svelte";
  import CustomFields from "../../components/CustomFields/CustomFields.svelte";
  // import UserTimeStats from "../../components/Business/UserTimeStats.svelte";
  import ClfDropdown from "../../components/Form/Fields/Dropdown/ClfDropdown.svelte";
  import Input from "../../components/Form/Fields/Input.svelte"; 
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import Textarea from "../../components/Form/Fields/Textarea.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import type { ICompany, ICompanyData } from "../../entities";
  import FormLayout from "../../layout/FormLayout.svelte";
  import type { IApiResponse } from "../../utils/api/api-response";
  import { formatTimestampHuman } from "../../utils/date-utils";
  import { PermissionService } from "../../utils/misc/permission-utils";
    import { user } from "../../app.store";

  import {
    recordData,
    saveData,
  } from "./company.store";
import Switch from "../../components/Form/Fields/Switch.svelte";
import MagazineSideEditor from "../../components/Business/MagazineSideEditor.svelte";
import Secur8SideEditor from "../../components/Business/Secur8SideEditor.svelte";
import { showToast } from "../../utils/misc/toast-utils";
import ActivityListEditor from "../../components/Business/ActivityListEditor.svelte";
import type { IActivityDTO } from "../../services/DTO";

  export let oid: number;

  $: isNew = oid == 0;
  $: canSubmit = $recordData  != null;

  let issupplier = window.location.pathname.indexOf("supplier") >= 0;

  let cancreate: boolean = PermissionService.isAllowedTo($user, 'companies.cancreate');
  let canedit : boolean = true;// PermissionService.isAllowedTo($user, 'companies.canedit'); 
  
  async function onSubmit() {
    let newP = isNew;
    let _resp: IApiResponse<ICompanyData> = await saveData();
    let u = _resp.payload;    
    
    showToast("Operazione completata", 'is-success' );
  }

  function onCancel() {
    navigate(`/company`);
  }

  // onMount(() => initDetail(oid));
</script>

{#if $recordData}
  <div class="columns">
    <div class="column is-12">
      <FormLayout submitEnabled={canedit && !isNew} {canSubmit} {isNew} on:submit={onSubmit} on:cancel={onCancel}>
      
        <div class="columns">
          <div class="column is-6">
            <FormField>
                <Input
                name="Responsabile CATA"
                placeholder="Ragione Sociale"
                required={false}
                bind:value={$recordData.referenteCata}
                disabled={!(canedit)}
              />
            </FormField>
          </div>

          <div class="column is-3">
            <FormField>
              <Switch
                name="RSPP Interno"
                bind:value={$recordData.rsppInternoInterno}
                disabled={!(canedit)}
              />
            </FormField>
          </div>
          <div class="column is-3">
            <FormField>
              <Switch
                name="RSPP Esterno CATA"
                bind:value={$recordData.rsppEsternoCata}
                disabled={!(canedit) || $recordData.rsppInternoInterno==1}
              />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column is-4">
             <FormField>
              <ClfDropdown
                name="Magazine"
                schema="MAGAZINEXX"
                required={false}
                clearVisible={false}
                bind:value={$recordData.clfMagazineId}
              />               
            </FormField>
          </div>

          <div class="column is-4">
            <FormField>
              <ClfDropdown
                  name="Secur8"
                  schema="SECUR8XXXX"
                  required={false} 
                  bind:value={$recordData.clfSecur8Id} 
                />             
            </FormField>
          </div> 
        </div>

        <div class="columns">
          <div class="column is-12">
            <FormField>
                <Input
                name="URL Google Drive"
                placeholder="URL Google Drive"
                required={false}
                bind:value={$recordData.urlGoogleDrive}
                disabled={!(canedit)}
              />
            </FormField>
          </div>
 
        </div>

        <div class="columns">
          <div class="column is-4">
            <FormField>
              <ClfDropdown
                  name="Associazione di categoria"                           
                  schema="ASSCATEGOR"
                  required={false} 
                  bind:value={$recordData.clfAssociazione} 
                />             
            </FormField>
          </div> 

          <div class="column is-4">
            <FormField>
                <Input
                name="Codice INPS"
                placeholder="Codice INPS"
                required={false}
                bind:value={$recordData.codiceInps}
                disabled={!(canedit)}
              />
            </FormField>
          </div>
 
 
        </div>

        <div class="columns" style="border-bottom: 1px solid;">
          <span class="content is-medium">Fondo dipendenti</span>
        </div>

        <div class="columns">
          <div class="column is-4">
            <FormField>
              <ClfDropdown
                  name="Fondo interprofessionale dipendenti" 
                  schema="FONDODIPXX"
                  required={false} 
                  bind:value={$recordData.clfFondoDipendenti} 
                />             
            </FormField>
          </div> 

          <div class="column is-4">
            <FormField>
                <Input
                name="Username fondo dipendenti"
                placeholder="Username"
                required={false}
                bind:value={$recordData.userFondoDip}
                disabled={!(canedit)}
              />
            </FormField>
          </div>

          <div class="column is-4">
            <FormField>
                <Input
                name="Password fondo dipendenti"
                placeholder="Password"
                required={false}
                bind:value={$recordData.passwordFondoDip}
                disabled={!(canedit)}
              />
            </FormField>
          </div>
 
        </div>
        <div class="columns">
           
          <div class="column is-4">
            <FormField>
                <NumberInput
                name="Credito disponibile fondo dipendenti"
                placeholder="Importo"
                required={false}
                bind:value={$recordData.creditoDispDip}
                disabled={!(canedit)}
              />
            </FormField>
          </div>

          <div class="column is-4">
            <FormField>
                <NumberInput
                name="Credito maturando fondo dipendenti"
                placeholder="Importo"
                required={false}
                bind:value={$recordData.creditoMapDip}
                disabled={!(canedit)}
              />
            </FormField>
          </div>
 
          <div class="column is-4">
            <FormField>
              <Input
                name="Ult. Aggiornamento password"
                placeholder=""
                required={false}
                readonly={true}
                value={$recordData.dataFondoDip != null
                  ? formatTimestampHuman($recordData.dataFondoDip)
                  : ""}
              />
            </FormField>
          </div>
        </div>

        <div class="columns" style="border-bottom: 1px solid;">
          <span class="content is-medium">Fondo dirigenti</span>
        </div>

        <div class="columns">
          <div class="column is-4">
            <FormField>
              <ClfDropdown
                  name="Fondo interprofessionale dirigenti" 
                  schema="FONDODIRXX"
                  required={false} 
                  bind:value={$recordData.clfFondoDirigenti} 
                />             
            </FormField>
          </div> 

          <div class="column is-4">
            <FormField>
                <Input
                name="Username fondo dirigenti"
                placeholder="Username"
                required={false}
                bind:value={$recordData.userFondoDir}
                disabled={!(canedit)}
              />
            </FormField>
          </div>

          <div class="column is-4">
            <FormField>
                <Input
                name="Password fondo dirigenti"
                placeholder="Password"
                required={false}
                bind:value={$recordData.passwordFondoDir}
                disabled={!(canedit)}
              />
            </FormField>
          </div>
 
        </div>
        <div class="columns">
           
          <div class="column is-4">
            <FormField>
                <NumberInput
                name="Credito disponibile fondo dirigenti"
                placeholder="Importo"
                required={false}                
                bind:value={$recordData.creditoDispDir}
                disabled={!(canedit)}
              />
            </FormField>
          </div>

          <div class="column is-4">
            <FormField>
                <NumberInput
                name="Credito maturando fondo dirigenti"
                placeholder="Importo"
                required={false}
                bind:value={$recordData.creditoMapDir}
                disabled={!(canedit)}
              />
            </FormField>
          </div>
 
          <div class="column is-4">
            <FormField>
              <Input
                name="Ult. Aggiornamento password"
                placeholder=""
                required={false}
                readonly={true}
                value={$recordData.dataFondoDir != null
                  ? formatTimestampHuman($recordData.dataFondoDir)
                  : ""}
              />
            </FormField>
          </div>
        </div>
        
      </FormLayout>
    </div>
    
  </div>
{/if}
